import axios from "axios";

export const getPDFDownload = (data, resp, error) => {
    const params = { org_id: data?.Org_Id, sign_id: data?.sign_id };
    if (typeof data?.type !== 'undefined') params.type = data.type;
    if (typeof data?.download_option !== 'undefined') params.download_option = data.download_option;
    if (typeof data?.include_certificate !== 'undefined') params.include_certificate = data.include_certificate;

    axios.get(process.env.REACT_APP_PDFDOWNLOAD, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
        params,
        responseType: 'arraybuffer'
    })
        .then((res) => {
            resp(res);
        })
        .catch((err) => {
            error(err);
        });
};
